import React from "react";
import { Link } from "react-router-dom";
import { FileText, ClipboardList, FolderOpen, Users } from "lucide-react";

/**
 * AdminHome
 * A simple landing page for the admin area that routes users to the
 * specific tooling they need (legacy profiles, questionnaire templates,
 * brand profiles).
 */
const AdminHome = () => {
  const cards = [
    {
      title: "Legacy Profiles",
      description: "View & edit old profiles (read-only for most cases)",
      to: "/admin/legacy-profiles",
      icon: FolderOpen,
      color: "bg-gray-700/20 text-gray-300",
      badge: "Legacy",
    },
    {
      title: "Questionnaire Templates",
      description:
        "Template Builder/Selector - Build or modify dynamic questionnaire templates",
      to: "/admin/questionnaire/templates",
      icon: FileText,
      color: "bg-primary-green/20 text-primary-green",
    },
    {
      title: "Brand Profiles",
      description:
        "Brand Profile Editor - Browse and analyze submitted questionnaire responses",
      to: "/admin/questionnaire/responses",
      icon: ClipboardList,
      color: "bg-violet-500/20 text-violet-400",
    },
    {
      title: "Client Onboarding",
      description:
        "Live Onboarding Form - Manage onboarding forms and submissions for new clients",
      to: "/admin/onboarding",
      icon: Users,
      color: "bg-cyan-500/20 text-cyan-400",
    },
  ];

  return (
    <div className="p-6 md:p-10">
      <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">
        Admin Home
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map(({ title, description, to, icon: Icon, color, badge }) => (
          <Link
            key={title}
            to={to}
            className="group rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 transition-colors p-6 flex flex-col justify-between min-h-[180px]"
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`p-3 rounded-lg ${color}`}>
                <Icon className="w-6 h-6" />
              </div>
              {badge && (
                <span className="text-xs px-2 py-1 rounded-full bg-white/10 text-white/60 uppercase tracking-wide">
                  {badge}
                </span>
              )}
            </div>
            <h2 className="text-xl font-medium text-white mb-2">{title}</h2>
            <p className="text-sm text-white/60 leading-snug flex-1">
              {description}
            </p>
            <span className="mt-4 inline-flex items-center text-primary-green group-hover:underline text-sm">
              Open
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminHome;
